module.exports = __webpack_public_path__ + "img/research-group-3.14d2db05.jpg";